<template>
    <div class="mit-maps-page mit-page">
        <v-container fluid>
        <v-row no-gutters>
          <v-col cols="12" class="d-flex">
            <v-card class="mit-info-card">
              <v-card-title>Remove Person</v-card-title>
              <v-card-subtitle class="caption">Remove an existing lab member</v-card-subtitle>
              <v-divider></v-divider>

              <v-card-text>

              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>
</template>

<script>

  export default {
    name: 'MitManageAuditPage',
    components: {
    },
    data: function() {
      return {

      }
  },
    created(){

    },
    methods : {
    }
  }
</script>

<style lang="scss" scoped>
.mit-info-card {
  width:100%;
  height:100%;
}
</style>
